@for (product of products; track product) {
<epc-epic-show-presentation-pcard
  class="mr-3 mr-md-0"
  [product]="product"
  [titleFields]="productTitleFields$ | async"
  [idFields]="idFields$ | async"
  [isInActiveList]="
    isProductInActiveList(activeListProductReferences$ | async, product)
  "
  (addToListClicked)="onAddToListClicked($event)"
  (openCStripClicked)="onOpenCSTripClicked($event)"
>
</epc-epic-show-presentation-pcard>
}
